import { SVGProps } from 'react'

const SvgNintendo = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg viewBox='0 0 24 24' className='svg-icon' {...props}>
            <path
                d='M5.58913 2.2186C7.11025 1.29706 8.78061 0.749023 10.8005 0.749023C12.8203 0.749023 14.4912 1.29706 16.0123 2.2186C16.0371 2.2186 16.0371 2.24311 16.0371 2.26792V2.26821C16.0371 2.29312 16.0124 2.29351 15.9875 2.29351C14.0424 1.8701 11.1001 3.53863 10.8258 3.71298H10.8005H10.7756C10.5013 3.53863 7.55901 1.8701 5.61397 2.29351C5.58903 2.29351 5.5638 2.29312 5.5638 2.26821C5.5638 2.24331 5.56419 2.2186 5.58913 2.2186Z'
                fill='#E4E4E7'
            />
            <path
                d='M13.5435 6.22842C15.8439 3.96817 16.9941 3.58553 17.4885 3.55634C17.6533 3.54661 17.7453 3.57599 17.7827 3.58844H17.783C17.8076 3.58844 17.808 3.58844 17.8329 3.61325C19.6782 5.43142 20.8004 7.94696 20.8004 10.7116C20.8004 12.978 20.0271 15.0953 18.7553 16.764C18.7553 16.7888 18.7308 16.7888 18.7059 16.7888H18.7056V16.7392C19.4537 14.3731 15.5633 8.66954 13.5435 6.27853C13.5185 6.27853 13.5186 6.25323 13.5186 6.25323L13.5435 6.22842Z'
                fill='#E4E4E7'
            />
            <path
                d='M3.79341 3.61325C3.83704 3.59457 3.93387 3.56043 4.10219 3.56704C4.60716 3.58689 5.75706 3.9743 8.05745 6.25323C8.08238 6.25323 8.08278 6.25362 8.08278 6.27853L8.05745 6.30334C6.03759 8.69435 2.12276 14.3979 2.89579 16.764C2.92073 16.7889 2.92073 16.8136 2.89579 16.8136H2.8955C2.87066 16.8136 2.84611 16.8136 2.84611 16.7888C1.57435 15.1201 0.801025 13.0029 0.801025 10.7364C0.801025 7.97177 1.92336 5.45623 3.74373 3.63806C3.76866 3.63806 3.76847 3.61325 3.79341 3.61325Z'
                fill='#E4E4E7'
            />
            <path
                d='M10.7756 8.79397C10.7756 8.76907 10.8005 8.76916 10.8005 8.76916C10.8005 8.76916 10.8258 8.76907 10.8258 8.79397C13.8182 11.0605 18.9299 16.6892 17.3838 18.2832C15.6133 19.8274 13.3191 20.749 10.8005 20.749C8.28188 20.749 5.96318 19.8274 4.21762 18.2832C2.64662 16.6892 7.78325 11.0605 10.7756 8.79397Z'
                fill='#E4E4E7'
            />
        </svg>
    )
}

export default SvgNintendo
